<template>
  <div>
    <profile-app-bar
      title="Omat kommentit"
      prev-page="/profiili"
    />

    <div
      class="pa-4"
    >
      <v-layout
        v-if="$wait.is('loading posts')"
        justify-center
        align-center
        fill-height
        class="pt-12"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-layout>

      <router-view
        :style="{
          display: $wait.is('loading comments') ? 'none' : 'block',
        }"
      />
    </div>
  </div>
</template>

<script>
import ProfileAppBar from '../components/ProfileAppBar.vue';

export default {
  components: {
    ProfileAppBar,
  },
};
</script>
